// This file provides a common set of helpers for interacting with organizations.
const { REACT_APP_STATIC_URL, REACT_APP_COMPANY_IMAGES } = process.env;

const logoURL = id => {
  return REACT_APP_STATIC_URL + REACT_APP_COMPANY_IMAGES.replace('{id}', id);
};

export { logoURL };
